import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { TaskCounts } from '@lyceo/shared/task-count/util';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import { AuthActions } from '@lyceo/shared/auth/data-access';
import { TaskCountActions } from './task-count.actions';

export const TASK_COUNT_FEATURE_KEY: string = 'taskCount';

export interface TaskCountState {
  taskCounts: TaskCounts;
  countCallState: CallState;
}

export const initialTaskCountState: TaskCountState = {
  taskCounts: {
    tasksToPlan: 0,
    parentTasksUpcoming: 0,
    subTasksToday: 0,
    tasksDoneToday: 0,
  },
  countCallState: LoadingState.INIT,
};

const reducer: ActionReducer<TaskCountState, Action> = createReducer(
  initialTaskCountState,
  on(AuthActions.logoutSuccess, (): TaskCountState => initialTaskCountState),
  on(
    TaskCountActions.getTaskCounts,
    (state): TaskCountState => ({
      ...state,
      countCallState: LoadingState.LOADING,
    }),
  ),
  on(
    TaskCountActions.getTaskCountsSuccess,
    (state, { taskCounts }): TaskCountState => ({
      ...state,
      taskCounts: taskCounts,
      countCallState: LoadingState.LOADED,
    }),
  ),
  on(
    TaskCountActions.getTaskCountsFailure,
    (state, { error }): TaskCountState => ({
      ...state,
      countCallState: { errorMsg: error.message },
    }),
  ),
);

export function taskCountReducer(
  state: TaskCountState | undefined,
  action: Action,
): TaskCountState {
  return reducer(state, action);
}
